import { useReducer as Reducer } from 'react';


export const useReducer = (props) => Reducer((state, updates) => ({ ...state, ...updates }), { ...props });